import React, {useContext, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Box, Card, CardContent, Typography} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {AuthContext} from '../App';
import {merchantId} from "../constants/Constants";
import {API_KEY} from "../constants/Constants";
import {demoStoreUrl} from "../constants/Constants";
import {hostUrl} from "../constants/Constants";

const CartTotal = () => {
    const [cartID, setCartID] = React.useState("");
    const [orderID, setOrderID] = React.useState("");
    const currentUser = localStorage.getItem('user-id') ? JSON.parse(localStorage.getItem('user-id')) : null;
    const [returnPolicy, setReturnPolicy] = useState("");
    const [isAnalyzeLoading, setIsAnalyzeLoading] = useState(false);
    // const { cartItems, totalPr } = props.cartDetails;
    const {cartLen, cartItems} = useContext(AuthContext);//cartItems.length;
    const [checkoutLoader, setCheckoutLoader] = useState(false);
    const dispatch = useDispatch();
    const [totalPr, setTotalPr] = useState(0);

    // const totalPrice = cartItems.map(item => {
    //     return item.quantity * item.price;
    // }).reduce((totalPrice, singleItemPrice) => totalPrice + singleItemPrice, 0);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setCartLen, setCartItems} = useContext(AuthContext);


    const [items, setItems] = useState([]);
    let tempTotalPr = 0;


    useEffect(() => {
        let items = [];
        console.log(cartItems);
        if(cartItems.length > 0) {
            for (let i = 0; i < cartItems.length; i++) {
                items.push({
                  identifiers: [
                    {
                      identifierType: "SKU",
                      identifier: cartItems[i].itemId,
                    },
                  ],
                  category: cartItems[i].category ?? "Fashion",
                  image_url: cartItems[i].imageTag,
                  title: cartItems[i].name,
                  quantity: cartItems[i].quantity,
                  unitPrice: {
                    currencyCode: "840",
                    amount: cartItems[i].price,
                  },
                });
                tempTotalPr += cartItems[i].price * cartItems[i].quantity;
                console.log("totalPr: " + totalPr);
            }
            setItems(items)
            setTotalPr(tempTotalPr);
            console.log('in fetch inside')
        }
    }, [cartItems]);

    const handleCheckout = () => {
        console.log("CartID: " + cartID);
        setCheckoutLoader(true);
        const sendPurchase = async () => {
            try {
                var purchaseHeaders = new Headers();
                purchaseHeaders.append("Accept", "*/*");
                purchaseHeaders.append("Authorization", API_KEY);
                purchaseHeaders.append("Content-Type", "application/json");
                purchaseHeaders.append("Access-Control-Allow-Origin", "*");

                const purchaseRequest = JSON.stringify(
                    {
                        "providerOrderId":`order-${merchantId}-${new Date().getTime()}`,
                        "intent": "Order",
                        "state": "PAID",
                        "totalPrice": {
                            "currencyCode": "840",
                            "amount": tempTotalPr
                        },
                        "lineItems": items,
                        "deviceFingerprints": [
                            {
                                "deviceIdentifier": "dshkjankjdnka3320200sjkndkj22skndk"
                            }
                        ],
                        "customer": {
                            "providerCustomerId": currentUser.id,
                            "fullName": currentUser.name,
                            "contactInformation": [
                                {
                                    "contactType": "ContactAddress",
                                    "address": {
                                        "line1": currentUser.addressLine1,
                                        "line2": currentUser.addressLine2,
                                        "line3": null,
                                        "line4": null,
                                        "city": currentUser.city,
                                        "state": "WA",
                                        "postalCode": "67871",
                                        "country": currentUser.country,
                                        "geoCode": {
                                            "longitude": "-95.498518",
                                            "latitude": "29.467289"
                                        },
                                        "phone": "9898989898"
                                    },
                                    "addressType": "Billing"
                                },
                                {
                                    "contactType": "ContactAddress",
                                    "address": {
                                        "line1": currentUser.addressLine1,
                                        "line2": currentUser.addressLine2,
                                        "line3": null,
                                        "line4": null,
                                        "city": currentUser.city,
                                        "state": "WA",
                                        "postalCode": "67871",
                                        "country": currentUser.country,
                                        "geoCode": {
                                            "longitude": "-95.498518",
                                            "latitude": "29.467289"
                                        },
                                        "phone": "9898989898"
                                    },
                                    "addressType": "Shipping"
                                },
                                {
                                    "contactType": "EMail",
                                    "address": currentUser.email
                                },
                                {
                                    "contactType": "Phone",
                                    "phone": "9898989898"
                                }
                            ]
                        },
                        "paymentInfo": [
                            {
                                "amount": {
                                    "currencyCode": "840",
                                    "amount": tempTotalPr
                                },
                                "instrument": "Cash",
                                "last4": "string",
                                "BIN": "40",
                                "postalCode": "string",
                                "method": "NotPresent",
                                "auth": "string",
                                "AID": "string"
                            }
                        ],
                        "merchant": {
                            "brand": "All Stars",
                            "providerMerchantId": "MERCHANT-1234",
                            "locationInfo": {
                                "name": "OUTLET-12",
                                "address": {
                                    "line1": currentUser.addressLine1,
                                    "line2": currentUser.addressLine2,
                                    "line3": null,
                                    "line4": null,
                                    "city": currentUser.city,
                                    "state": "WA",
                                    "postalCode": "67871",
                                    "country": currentUser.country,
                                    "geoCode": {
                                        "longitude": "-95.498518",
                                        "latitude": "29.467289"
                                    },
                                    "phone": "9898989898"
                                },
                            }
                        }
                    }
                );

                var requestOptions = {
                    method: 'POST',
                    headers: purchaseHeaders,
                    body: purchaseRequest,
                    redirect: 'follow'
                };
                console.log(items)
                // Purchase call
                const response = await fetch(`${hostUrl}/v1/order`, requestOptions)
                console.log("response: " + response.status + " " + response.statusText);
                if (!response.ok) {
                    throw new Error('Error completing purchase');
                }

                const result = await response.json();
                console.log("Result for purchase:" + result.providerOrderId);
                setOrderID(result.providerOrderId);
                sendDataToOrderList(result.providerOrderId);
            } catch (error) {
                console.log("error: " + error);
            }
        };

        sendPurchase();
    };


    const sendDataToOrderList = (responseOrderId) => {
        console.log("orderId: " + responseOrderId);
        // const response = fetch("localhost:8080/v1/order/", requestOptions) 
        // dispatch(orderActions.addOrder({ id: responseOrderId, product: cartItems.map(item => item.name).join(', '), price: totalPr }));
        console.log("Order added at CartTotal.js");

        // Reset cart state and clear local storage
        // cartItems.forEach(item => {
        //     console.log(item);
        //     dispatch(cartActions.removeItemFromCart(item.id));
        // });

        const clearCartItems = async () => {
            setTimeout(() => {
                setCartLen(0);
                setCartItems([]);
            }, 1000);

            var myHeaders = new Headers();
            myHeaders.append("userId", currentUser.id);
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: 'DELETE',
                headers: myHeaders,
                redirect: 'follow'
            };

            const response = await fetch(`${demoStoreUrl}/v1/item/clear`, requestOptions);
            const result = await response.text();
            console.log("Cart cleared: " + result);
            console.log("response: " + response.status + " " + response.statusText);
        };
        clearCartItems();


        const sendToOrderList = async () => {
            try {
                var orderHeaders = new Headers();
                orderHeaders.append("userId", currentUser.id);
                orderHeaders.append("Content-Type", "application/json");
                console.log("responseOrderId: " + responseOrderId);
                console.log("currentUser.id: " + currentUser.id);

                var raw = JSON.stringify({
                    "userId": null,
                    "orderId": responseOrderId,
                    "price": totalPr,
                    "status": "Delivered",
                    "returnId": null,
                    "product": cartItems.map(item => item.itemId).join(','),
                    "productCategory": cartItems.map(item => item.category).join(','),
                    timestamp: new Date().getTime()
                });
                var requestOptions = {
                    method: 'POST',
                    headers: orderHeaders,
                    body: raw,
                    redirect: 'follow'
                };

                const result = await fetch(`${demoStoreUrl}/v1/order`, requestOptions);
                console.log("response: " + result.status + " " + result.statusText);
            } catch (error) {
                console.log("error: " + error);
            }
        };

        sendToOrderList();

    }

    const handleClickOpen = () => {
        setCheckoutLoader(true);
        handleCheckout();
        // setOpen(true);
    };

    const card = (
        <React.Fragment>
            <CardContent>
                <Typography variant="h6" className="cart-total-header" sx={{fontSize: 14}} color="text.secondary"
                            gutterBottom>
                    <b>Billing details</b>
                </Typography>
                <div>
                    <div className='price-item'>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            <b>Total</b>
                        </Typography>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            ${totalPr}
                        </Typography>
                    </div>
                    <div className='price-item'>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            <b>Shipping</b>
                        </Typography>
                        <div className='price-item no-border'>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                                {totalPr < 100 ? <p> $15 </p> : <p>
                                    <del>$15</del>
                                </p>}
                            </Typography>
                            {
                                totalPr >= 100 ?
                                    <p className='free-shipping'><b>FREE</b></p>
                                    : null
                            }
                        </div>

                    </div>
                    <div className='price-item'>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            <b>Platform fee</b>
                        </Typography>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            $5
                        </Typography>
                    </div>
                    <div className='price-item'>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            <b>Tax</b>
                        </Typography>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            ${((totalPr * 5) * 1.0) / 100}
                        </Typography>
                    </div>
                    <div className='price-item total-summary'>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            <b>Total amount</b>
                        </Typography>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            ${Math.round(totalPr + (totalPr < 100 ? 20 : 0) + 5 + ((totalPr * 5) * 1.0) / 100)}
                        </Typography>
                    </div>
                    <br/>
                    <br/>
                    <div>
                        <h3><b>Return Policy</b></h3>
                        *<em>
                        Free returns are available within 30 days of purchase.
                        Customers have the option to exchange their product or receive a refund to the original payment
                        method. This offer is valid within 14 days of us receiving the return.
                    </em>

                        <p>
                            <br/>
                            <em>
                                We monitor return activity for abuse and reserve the right to limit returns or exchanges
                                in
                                all instances.
                            </em>
                        </p>

                        <br/>
                        <br/>
                        {checkoutLoader ?
                            <Alert severity="success">
                                <span>Order placed successfully</span>
                            </Alert>
                            :
                            <button onClick={handleClickOpen} className='spAddTOCart checkoutBtn'>
                                <div className=' text-center'>
                                    Place order
                                </div>
                            </button>
                        }
                    </div>
                </div>
            </CardContent>
        </React.Fragment>
    );


    return (

        <div>
            <Box className="price-details" sx={{display: 'flex'}}>
                <Card variant="outlined">{card}</Card>
            </Box>

        </div>
    );
};

export default CartTotal;
